// ACTIONS
export const SUBMIT_REASON = 'offerzen/postLiveReason/SUBMIT_REASON'
export const SUBMIT_REASON_SUCCESS = 'offerzen/postLiveReason/SUBMIT_REASON_SUCCESS'

// ACTION CREATORS
export const submitReason = (data, id, resolve, reject) => ({
  type: SUBMIT_REASON,
  payload: { data, id, resolve, reject },
})

export const submitReasonSuccess = ({ dashboard_state }) => ({
  type: SUBMIT_REASON_SUCCESS,
  payload: { dashboard_state },
})
